<template>
  <div :class="$style.popin">
    <div
      :class="$style.overlay"
      @click="close"
    />
    <div :class="$style.container">
      <button
        :class="$style.close"
        type="button"
        @click="close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.615"
          height="15.615"
          viewBox="0 0 15.615 15.615"
        >
          <g
            stroke="#fff"
            stroke-width=".5"
          >
            <path
              d="M2.061.624A1.016 1.016 0 0 0 .624 2.061l12.93 12.93a1.016 1.016 0 1 0 1.437-1.437Z"
            />
            <path
              d="M.624 13.554a1.016 1.016 0 0 0 1.437 1.437l12.93-12.93A1.016 1.016 0 1 0 13.554.624Z"
            />
          </g>
        </svg>
      </button>
      <div :class="$style.main">
        <div :class="$style.content">
          <div :class="$style.header">
            <div :class="$style.result">
              <div :class="$style.rank">
                <div>
                  #{{ rank }}<sup>{{ rank === 1 ? 're' : 'e' }}</sup>
                  <span> place</span>
                </div>
              </div>
              <div :class="$style.record">
                <div>
                  <template v-if="isScoreContest">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 17.332 16.094"
                    >
                      <path
                        fill="currentColor"
                        d="M16.674 5.571h-5.691L9.25.41a.627.627 0 0 0-1.176 0L6.35 5.571H.619A.621.621 0 0 0 0 6.19a.455.455 0 0 0 .012.1.6.6 0 0 0 .259.437l4.679 3.298-1.8 5.222a.621.621 0 0 0 .213.7.6.6 0 0 0 .348.151.758.758 0 0 0 .387-.139l4.565-3.254 4.565 3.254a.725.725 0 0 0 .387.139.556.556 0 0 0 .344-.151.613.613 0 0 0 .213-.7l-1.792-5.222 4.639-3.327.112-.1a.592.592 0 0 0-.457-1.033Z"
                      />
                    </svg>
                  </template>
                  <template v-else-if="isRunContest">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 15.857 15.861"
                    >
                      <g fill="currentColor">
                        <path
                          d="M7.93 15.862a7.931 7.931 0 0 1-5.5-13.641.637.637 0 1 1 .884.916 6.656 6.656 0 1 0 5.248-1.833v2.482a.638.638 0 0 1-1.277 0V.638A.638.638 0 0 1 7.923 0a7.931 7.931 0 0 1 0 15.861Z"
                        />
                        <path
                          d="m4.754 4.199 3.945 2.835a1.194 1.194 0 0 1-1.387 1.939 1.153 1.153 0 0 1-.278-.278L4.199 4.75a.4.4 0 0 1 .555-.555Z"
                        />
                      </g>
                    </svg>
                  </template>
                  {{ activityWording }}
                </div>
                <span>{{ formattedRecord }}</span>
              </div>
            </div>
            <div :class="$style.buttons">
              <button
                type="button"
                :class="[
                  $style.button,
                  { [$style['is-liked']]: social.is_liked },
                ]"
                @click="updateLike"
              >
                {{ kFormatter(social.likes_count) }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.804"
                  height="15.731"
                  viewBox="0 0 17.804 15.731"
                >
                  <path
                    d="M17.804 7.615a2.188 2.188 0 0 1-.109.333c-.1.2-.219.383-.323.578a.247.247 0 0 0-.039.178 1.765 1.765 0 0 1-.292 1.8.193.193 0 0 0-.041.218 1.727 1.727 0 0 1-.232 1.683.422.422 0 0 0-.084.387 1.888 1.888 0 0 1-.446 1.853 1.635 1.635 0 0 1-.892.474 5.151 5.151 0 0 1-.915.1H7.655a2.075 2.075 0 0 1-1.143-.373.428.428 0 0 0-.339-.086 2.441 2.441 0 0 1-.027.326.713.713 0 0 1-.654.64 1.408 1.408 0 0 1-.155 0H.827a.763.763 0 0 1-.823-.7V7.928a.795.795 0 0 1 .835-.845h5.088a2.851 2.851 0 0 1 .357.068.243.243 0 0 0 .178-.021 5.533 5.533 0 0 0 .519-.58 23.722 23.722 0 0 0 1.851-3.04 1.1 1.1 0 0 0 .134-.569c-.023-.587-.023-1.176-.047-1.762a.974.974 0 0 1 .515-.927 1.9 1.9 0 0 1 2.063.114 1.176 1.176 0 0 1 .322.475c.219.535.428 1.082.613 1.633a3.532 3.532 0 0 1 .075 1.851c-.093.469-.16.943-.241 1.414-.027.16-.021.178.143.178h3.854a1.649 1.649 0 0 1 .892.212 1.347 1.347 0 0 1 .594.849c.014.055.032.109.048.162v.483Zm-6.457-.963c.139-.826.28-1.633.408-2.441a3.594 3.594 0 0 0 .08-.87 7.146 7.146 0 0 0-.7-2.2.535.535 0 0 0-.4-.357 1.206 1.206 0 0 0-.892.078.319.319 0 0 0-.194.325q.036.974.036 1.947a1.325 1.325 0 0 1-.077.455 3.122 3.122 0 0 1-.26.535c-.535.876-1.07 1.755-1.619 2.62a3.355 3.355 0 0 1-.958 1.07c-.253.164-.508.332-.754.5a.242.242 0 0 0-.1.164v5.289c0 .105.045.116.136.127a2.569 2.569 0 0 1 .506.105 1.4 1.4 0 0 1 .316.191 1.577 1.577 0 0 0 .909.273h6.712a3.057 3.057 0 0 0 .4-.023 1.163 1.163 0 0 0 .824-.476.815.815 0 0 0 .046-1 2.173 2.173 0 0 0-.412-.312.32.32 0 0 1 .114-.123 1.154 1.154 0 0 0 .831-.8.722.722 0 0 0-.228-.829 2.965 2.965 0 0 0-.4-.219.513.513 0 0 1 .159-.153 1.1 1.1 0 0 0 .678-.483.783.783 0 0 0-.357-1.273.155.155 0 0 1-.093-.1.132.132 0 0 1 .114-.148 1.109 1.109 0 0 0 .851-.958.713.713 0 0 0-.389-.822 1.307 1.307 0 0 0-.5-.093h-4.8ZM5.26 7.841c-.057 0-.1-.009-.141-.009H.897a.123.123 0 0 0-.152.153v6.856a.135.135 0 0 0 .166.168h4.166c.178 0 .178 0 .178-.187V7.846Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <button
                v-if="social.hide_comments === false"
                type="button"
                :class="$style.button"
                @click="goToComment"
              >
                {{ kFormatter(social.comments_count) }}
                <img
                  src="~assets/icons/comment.svg"
                  alt="commentaires"
                />
              </button>
            </div>
          </div>
          <div :class="$style.participations">
            <div :class="$style.current">
              <time
                :class="$style.datetime"
                :datetime="activeParticipation?.created_at"
              >
                {{
                  dateToStringDayMonthYear(activeParticipation?.created_at)
                }}</time
              >
              <ParticipationItem
                v-for="item in activeParticipation?.sc_records"
                :key="item.id"
                :item="item"
              />
            </div>
            <div
              v-if="previousParticipations?.length"
              :class="$style.old"
            >
              <p :class="$style.title">Les anciennes participations</p>
              <div :class="$style.scrollable">
                <div
                  v-for="previousParticipation in previousParticipations"
                  :key="previousParticipation.id"
                  :class="[
                    $style.scrollable__block,
                    { [$style['scrollable__block--solo']]: isSoloContest },
                  ]"
                >
                  <span :class="$style.datetime">
                    <time :datetime="previousParticipation.created_at">{{
                      dateToStringDayMonthYear(previousParticipation.created_at)
                    }}</time>
                    - {{ formatRecord(previousParticipation) }}
                  </span>
                  <div :class="$style.scrollable__item">
                    <ParticipationItem
                      v-for="participation in previousParticipation.sc_records"
                      :key="participation.id"
                      :item="participation"
                      :solo="isSoloContest"
                      side
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <aside
          v-if="social.hide_comments === false"
          :class="$style.sidebar"
        >
          <div>
            <template v-if="!authenticated">
              <h2 class="title-strat">Commenter cette publication ?</h2>
              <ButtonSimple
                label="Se connecter"
                @click="loginModal.open()"
              />
            </template>
            <template v-else>
              <h2 class="title-strat">Votre commentaire</h2>
              <div>
                <div :class="$style.editor">
                  <img
                    v-if="auth.data.value?.avatar"
                    :src="auth.data.value?.avatar.url"
                    alt=""
                    loading="lazy"
                    :class="$style.editor__avatar"
                  />
                  <ClientOnly>
                    <div :class="$style.editor__rte">
                      <TheEditor
                        ref="editorRef"
                        v-model="editorContent"
                        :list="false"
                        :mention="true"
                        :wapers-suggestions="wapersSuggestions"
                      />
                      <span
                        v-if="errors.content"
                        class="c-form__feedback is-invalid"
                      >
                        {{ errors.content }}
                      </span>
                    </div>
                  </ClientOnly>
                </div>
                <div class="u-d-f u-jc-fe">
                  <ButtonSimple
                    label="Publier"
                    @click="handleComment"
                  />
                </div>
              </div>
            </template>
            <div
              v-if="social.comments.length"
              :class="$style.comments"
            >
              <PostCommentItem
                v-for="comment in social.comments"
                :key="comment.id"
                :comment="{
                  ...comment,
                  slugParent: social.slug,
                  slugType: social.slugType,
                }"
                :from-zoom="true"
              />
              <button
                v-if="social.has_more_comments"
                type="button"
                :class="$style.more"
                @click="socialContestStore.showMoreContent()"
              >
                Voir plus de commentaires
              </button>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TheEditor from '@/components/shared/Editor/TheEditor.vue'
import { checkLoginModal } from '~/modals/checkLogin'
import { loginModal } from '~/modals/login'
import type { CustomScPost } from '~/types'
import {
  activityWordingKey,
  isRunContestKey,
  isRunSecondsContestKey,
  isScoreContestKey,
  isSoloContestKey,
} from '~/utils/provideKeys'

const emit = defineEmits<{
  changeDisplay: [state: boolean]
}>()

const wapersStore = useWapersStore()
const { userWapers } = storeToRefs(wapersStore)

const wapersSuggestions = computed(() => {
  return userWapers.value.map((waper, index) => ({
    id: index,
    name: waper.nickname,
    userId: waper.id,
    slug: waper.slug,
  }))
})

const recordContestsStore = useRecordContestsStore()
const { currentPost } = storeToRefs(recordContestsStore)

const activeParticipation = computed(() => {
  return currentPost.value?.sc_posts?.[0]
})

const previousParticipations = computed(() => {
  if (currentPost.value?.sc_posts?.length) {
    const [_, ...previousParticipations] = currentPost.value.sc_posts

    return previousParticipations || []
  }
  return []
})

const formattedRecord = computed(() => {
  return formatRecord(activeParticipation.value)
})

const rank = computed(() => {
  return currentPost.value?.position
})

const isScoreContest = inject(isScoreContestKey)
const isRunContest = inject(isRunContestKey)
const isRunSecondsContest = inject(isRunSecondsContestKey)
const isSoloContest = inject(isSoloContestKey)
const activityWording = inject(activityWordingKey)

const formatRecord = (participation?: CustomScPost) => {
  if (!participation) return ''
  if (isScoreContest?.value) {
    return formatNumber(participation.score)
  } else if (isRunContest?.value) {
    return formatRun(participation.run, isRunSecondsContest?.value)
  }

  return ''
}

const close = () => {
  emit('changeDisplay', false)
}

const auth = useAuth()

const { authenticated } = useAuthenticated()
const socialContestStore = useSocialContestStore()
const { social } = storeToRefs(socialContestStore)

const updateLike = async () => {
  if (!authenticated.value) {
    return checkLoginModal.open()
  }

  if (social.value.is_liked) {
    await socialContestStore.unlikeContent()
  } else {
    await socialContestStore.likeContent()
  }
}

const editorRef = ref<InstanceType<typeof TheEditor> | null>(null)
const { gtag } = useGtag()

const goToComment = () => {
  if (authenticated.value && currentPost.value) {
    gtag('event', 'social', {
      interaction: 'comment',
      target_url: currentPost.value.slug,
    })

    return editorRef.value?.editor?.commands.focus()
  }
  return checkLoginModal.open()
}

const loadingStore = useLoadingStore()
const editorContent = ref('')
const errors = ref<{
  [key: string]: unknown
  content?: string
}>({})

const handleComment = async () => {
  errors.value = {}
  loadingStore.updateStatus(true)

  const formData: {
    content: string
    contentEmbed?: string
    [key: string]: string | undefined
  } = {
    content: editorContent.value,
  }

  const images = formData.content.match(
    /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/g,
  )

  if (images?.length) {
    images.forEach((image, index) => {
      formData.content = formData.content.replace(
        image,
        `<!-- contentImage${index + 1} -->`,
      )
      formData[`contentImage${index + 1}`] = image.match(
        /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/,
      )?.[1]
    })
  }

  const embed = formData.content.match(
    /<iframe\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?><\/iframe>/,
  )

  if (embed) {
    formData.content = formData.content.replace(
      embed[0],
      '<!-- contentEmbed -->',
    )
    formData['contentEmbed'] = embed[1]
  }

  const { error } = await socialContestStore.commentContent({
    content: formData,
  })

  if (error) {
    const { statusCode, data } = error

    if (data.errors && statusCode && statusCode >= 400 && statusCode < 500) {
      Object.keys(data.errors).forEach((key) => {
        errors.value = {
          ...errors,
          [key]: data.errors[key].join(' '),
        }
      })
    }
    return loadingStore.updateStatus(false)
  }

  editorContent.value = ''
  editorRef.value?.editor?.commands.clearContent()
  return loadingStore.updateStatus(false)
}
</script>

<style lang="scss" module>
@use 'sass:string';

// Characters which are escaped by the escape-svg function
$_escaped-characters: (('<', '%3c'), ('>', '%3e'), ('#', '%23'));

// Replace `$search` with `$replace` in `$string`
// Used on our SVG icon backgrounds for custom forms.

// @author Hugo Giraudel
// @param {String} $string - Initial string
// @param {String} $search - Substring to replace
// @param {String} $replace ('') - New value
// @return {String} - Updated string
@function replace($string, $search, $replace: '') {
  $index: string.index($string, $search);

  @if $index {
    /* stylelint-disable-next-line scss/operator-no-newline-after */
    @return string.slice($string, 1, $index - 1) + $replace +
      replace(
        string.slice($string, $index + string.length($search)),
        $search,
        $replace
      );
  }

  @return $string;
}

// See https://codepen.io/kevinweber/pen/dXWoRw
@function escape-svg($string) {
  @if not string.index($string, 'data:image/svg+xml') {
    @error 'Invalid string parsed for a svg.';
  }

  @each $char, $encoded in $_escaped-characters {
    $string: replace($string, $char, $encoded);
  }

  @return $string;
}

.popin {
  position: fixed;
  inset: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 8;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb($black, 0.85);
}

.overlay {
  position: absolute;
  inset: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

// Container keep remove 70px as navigation height
.container {
  position: relative;
  z-index: 1;
  width: calc(100% - 30px);
  max-width: 1600px;
  height: calc(100% - 30px - 70px);
  margin-top: 70px;
  background-color: $white;

  @media (min-width: 992px) {
    width: calc(100% - 40px);
    height: calc(100% - 40px - 70px);
  }
}

.close {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 40px;
  height: 40px;
  padding: 0;
  background-color: rgba($white, 0.5);
  border: 0;
  border-radius: 5px;

  &:focus {
    outline-style: solid;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.header {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;

  @media (min-width: 992px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 50px;
    padding-top: 50px;
    padding-right: 10px;
  }
}

.main {
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: 100%;
  overflow-y: auto;

  @media (min-width: 992px) {
    flex-direction: row;
    gap: 20px; // 50px real gap, but 30px used in posts for sidebar + padding
    overflow-y: initial;
  }
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.result {
  display: flex;
  gap: 10px;
  align-items: center;

  @media (min-width: 360px) {
    gap: 15px;
  }
}

.rank {
  display: inline-flex;
  align-items: center;
  height: 60px;
  padding: 0 25px 0 15px;
  color: $white;
  font-family: 'SST Condensed';
  font-size: 28px;
  font-weight: 500;
  line-height: calc(4 / 3);
  background-image: linear-gradient(to right, #0d53c5 0%, #032874 45%);
  clip-path: polygon(0 0, 100% 0%, calc(100% - 10px) 100%, 0% 100%);

  @media (min-width: 992px) {
    padding-left: 50px;
    font-size: 34px;
  }

  sup {
    line-height: 1;
  }

  span {
    font-size: 20px;

    @media (min-width: 992px) {
      font-size: 26px;
    }
  }
}

.record {
  display: flex;
  flex-direction: column;
  font-family: 'SST Condensed';

  div {
    display: flex;
    align-items: center;
    color: $softDark;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;

    @media (min-width: 992px) {
      font-size: 16px;
    }

    svg {
      width: 16px;
      height: 16px;
      margin-right: 5px;
      object-fit: contain;
    }
  }

  span {
    color: $blue;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;

    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
}

.buttons {
  display: flex;
  width: calc(100% - 30px);
  margin: 0 auto;

  @media (min-width: 992px) {
    width: auto;
    margin: 0;
  }

  .button:not(:first-of-type) {
    border-left: 0;
  }
}

.button {
  display: flex;
  flex-grow: 1;
  gap: 15px;
  justify-content: center;
  align-items: center;
  padding: 20px 30px;
  background-color: transparent;
  border: 1px solid rgba($black, 0.2);
  border-radius: 0;
  cursor: pointer;

  @media (min-width: 992px) {
    flex-grow: 0;
  }

  &.is-liked {
    color: $blue;
  }
}

.sidebar {
  padding: 0 15px 50px;

  @media (min-width: 992px) {
    flex-shrink: 0;
    flex-basis: 430px;
    padding: 160px 50px 50px 0;
  }

  @media (min-width: 1280px) {
    flex-basis: 520px;
  }

  > div {
    max-height: 100%;
    overflow-y: auto;
  }
}

.participations {
  @media (min-width: 992px) {
    padding-right: 14px;
    padding-left: 50px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 16px;
    }

    &::-webkit-scrollbar-track {
      margin: 0 0 8px;
      background-color: $sideGrey;
      border-radius: 16px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $backgroundBlue;
      border: 4px solid $sideGrey;
      border-radius: 16px;
      transition: all 0.35s ease-in-out;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: $blue;
    }

    @supports (scrollbar-color: red blue) {
      & {
        padding-right: 30px; // Force full padding size for Gecko
        scrollbar-color: $backgroundBlue $sideGrey;
        scrollbar-width: auto; // thin;
      }
    }
  }
}

.datetime {
  display: inline-block;
  margin-bottom: 10px;
  color: $blue;
  font-size: 14px;
  font-weight: 500;
  line-height: calc(4 / 3);

  @media (min-width: 992px) {
    margin-bottom: 20px;
    font-size: 15px;
  }
}

.current {
  margin-bottom: 10px;
  padding: 0 15px;

  @media (min-width: 992px) {
    margin-bottom: 20px;
    padding: 0;
    overflow-y: revert;
  }
}

.old {
  padding: 40px 0;
  background-color: #f4f4f4;

  @media (min-width: 922px) {
    padding: 0;
    background-color: transparent;
  }

  .title {
    margin-bottom: 30px;
    padding-left: 15px;
    font-size: 16px;
    font-weight: 500;
    line-height: calc(4 / 3);
    text-transform: uppercase;

    @media (min-width: 922px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-left: 0;
      color: $blue;
      font-size: 20px;
      text-align: center;

      &::after {
        content: '';
        display: block;
        width: 10px;
        height: 15px;
        margin-top: 5px;
        background-image: url(escape-svg(
          "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='13.993' height='15' viewBox='0 0 13.993 15'>\
          <path fill='#{$blue}' d='M6.994 5.589 1.706.294A1 1 0 1 0 .294 1.71l5.995 6a1 1 0 0 0 1.379.029l6.038-6.024A1 1 0 1 0 12.294.299Z'/>\
          <path fill='#{$blue}' d='M6.994 12.589 1.706 7.294A1 1 0 1 0 .294 8.71l5.995 6a1 1 0 0 0 1.379.029l6.038-6.024a1 1 0 1 0-1.412-1.416Z'/>\
        </svg>"
        ));
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }
}

.scrollable {
  display: flex;
  padding-bottom: 10px;
  padding-left: 15px;
  overflow-x: auto;

  @media (min-width: 992px) {
    display: block;
    padding-bottom: 0;
    padding-left: 0;
    overflow-x: revert;
  }

  &__block {
    $_root-block: &;

    position: relative;
    flex-shrink: 0;
    padding: 0 15px;

    @media (min-width: 992px) {
      margin-bottom: 40px;
      padding: 0;
    }

    &:first-child {
      padding-left: 0;
    }

    // &:not(#{$_root-block}--solo) {
    &:not(:last-child) {
      border-right: 2px solid $blue;

      @media (min-width: 992px) {
        border-right: 0;
      }
    }

    // }

    .datetime {
      position: sticky;
      left: 0;
    }
  }

  &__item {
    display: flex;
    gap: 20px;
  }
}

.editor {
  display: flex;
  margin: 20px 0;

  @media (min-width: 992px) {
    margin-bottom: 30px;
  }

  &__avatar {
    display: none;
    flex-shrink: 0;
    width: 54px;
    height: 54px;
    margin-right: 30px;
    background: #ccc;
    border-radius: 50%;
    object-fit: cover;

    @media (min-width: 460px) {
      display: block;
    }
  }

  &__rte {
    flex-grow: 1;
  }
}

.comments {
  margin-top: 20px;
  word-break: break-word;
}

.more {
  display: block;
  width: 100%;
  padding: 10px 0;
  color: $blue;
  font-size: 16px;
  text-align: center;
  text-decoration: underline;
  background-color: transparent;
  border: 0;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
}
</style>

<style scoped>
.title-strat {
  margin-bottom: 20px;
}
</style>
